import { render, staticRenderFns } from "./FinalSubmitRedeemComponent.vue?vue&type=template&id=4e21eaf8&scoped=true&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform&"
import script from "./FinalSubmitRedeemComponent.vue?vue&type=script&lang=js&"
export * from "./FinalSubmitRedeemComponent.vue?vue&type=script&lang=js&"
import style0 from "./FinalSubmitRedeemComponent.vue?vue&type=style&index=0&id=4e21eaf8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e21eaf8",
  null
  
)

component.options.__file = "FinalSubmitRedeemComponent.vue"
export default component.exports